import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";
dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(utc);
const DEFAULT_LOCALE = new Intl.Locale("sv-SE");
const DEFAULT_DATE_DISPLAY = "YYYY-MM-DD HH:mm:ss";
const formatDefaultDuration = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor(seconds % 3600 / 60);
  const secs = Math.floor(seconds % 60);
  const mmss = `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  return hours > 0 ? `${hours}:${mmss}` : mmss;
};
const formatDuration = (seconds, display) => display ? dayjs.utc(dayjs.duration({
  seconds
}).asMilliseconds()).format(display) : formatDefaultDuration(seconds);
const formatDateTime = ({
  value,
  type,
  display,
  format,
  locale = DEFAULT_LOCALE.language
}) => {
  switch (type) {
    case "date":
    case "time":
    case "datetime":
      return dayjs(value, format, locale, true).format(DEFAULT_DATE_DISPLAY);
    case "duration":
      return formatDuration(value, display ?? void 0);
    default:
      console.warn("Unknown date type", type);
      return type;
  }
};
export {
  formatDateTime,
  formatDuration
};
